import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { FreebieModel } from './freebie.model';

export class FreebiesResponse extends GlobalResponseObject {
    data?: FreebieModel[];
  intlCode: any;
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: FreebieModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
        this.internalMessage=internalMessage;
    }
}

